module.exports = __webpack_public_path__ + "img/enerfuture-maccs-logo.22a5b38.jpg";